import { Component, OnInit } from '@angular/core';
import { WebNavbarComponent } from '../../web-components/web-navbar/web-navbar.component';
import { WebFooterComponent } from '../../web-components/web-footer/web-footer.component';

@Component({
    standalone: true,
    selector: 'app-termsAndConditions',
    templateUrl: './termsAndConditions.component.html',
    styleUrls: ['./termsAndConditions.component.css'],
    imports: [WebNavbarComponent, WebFooterComponent]
})
export class TermsAndConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
